// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Oswald_d8a5c6', '__Oswald_Fallback_d8a5c6'","fontStyle":"normal"},"className":"__className_d8a5c6","variable":"__variable_d8a5c6"};